module.exports = {
      id: "dh-symbol-usage",
      viewBox: "0 0 344.84 299.91",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#dh-symbol",
      toString: function () {
        return this.url;
      }
    }